export default __webpack_public_path__ + "d265b9bf063c62ee69a16b38a44bc1aa.png";